import List from '@utils/list'
import http from '@plugin/axios'
import Select from '@utils/common/select'
import statusDot from './components/statusdot.vue'
import SupplierInput from '@/components/multipleSelection/Input/SupplierInput.vue'
import Detail from './detail'

const { Search, Jurisdiction, Tabs, Table, Operation } = List
// 列表接口
function api(data: any) {
  const status = (data.condition.status || '')
  const params = {
    ...data,
    condition: {
      ...data.condition,
      status
    }
  }
  return http({
    url: '/examineProcess/getProcessPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
}

function revokeDisabled(selection: any) {
  if (selection.length === 0) return true
  if (selection.some((i: any) => i.status !== '1')) return 'performanceAppraisal.performanceAppraisal.tips2'
  if (selection.some((i: any) => !i.builderFlag)) return 'performanceAppraisal.performanceAppraisal.tips5'
  return false
}

function publishDisabled(selection: any) {
  if (selection.length === 0) return true
  if (selection.some((i: any) => i.status !== '2')) return 'performanceAppraisal.performanceAppraisal.tips3'
  if (selection.some((i: any) => !i.builderFlag)) return 'performanceAppraisal.performanceAppraisal.tips5'
  return false
}

function invalidateDisabled(selection: any) {
  if (selection.length === 0) return true
  if (selection.some((i: any) => i.status !== '0' && i.status !== '2')) return 'performanceAppraisal.performanceAppraisal.tips4'
  if (selection.some((i: any) => !i.builderFlag)) return 'performanceAppraisal.performanceAppraisal.tips5'
  return false
}
function deleteDisabled(selection: any) {
  if (selection.length === 0) return true
  if (selection.some((i: any) => i.status !== '0' && i.status !== '2')) return 'performanceAppraisal.performanceAppraisal.tips4'
  if (selection.some((i: any) => !i.builderFlag)) return 'performanceAppraisal.performanceAppraisal.tips5'
  return false
}

// 批量发布
async function batchPublish(this: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.publishTip`))
  await http({
    url: '/examineProcess/batchChangeStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { status: '4', ids: this.selection.map((it: any) => it?.id) }
  })
  this.refresh()
}

// 批量作废
async function batchInvalidate(this: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.invalidateTip`))
  await http({
    url: '/examineProcess/batchChangeStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { status: '3', ids: this.selection.map((it: any) => it?.id) }
  })
  this.refresh()
}

// 批量撤销
async function batchRevoke(this: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.revokeTip`))
  await http({
    url: '/examineProcess/batchChangeStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { status: '0', ids: this.selection.map((it: any) => it?.id) }
  })
  this.refresh()
}

// 批量删除
async function batchDelete(this: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.deleteTip`))
  await http({
    url: '/examineProcess/batchDeleteExamineProcess',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { ids: this.selection.map((it: any) => it?.id) }
  })
  this.refresh()
}

const jurisdiction = new Jurisdiction('performanceAppraisal.performanceAppraisal')
  .lib('add').text('add').to('PerformanceAppraisal.PerformanceAppraisal.Add').sort(10) // .main(true)
  .add('batchRevoke').icon('icon-chexiaotijiao').text('revoke').sort(20).disabled(revokeDisabled).handle(batchRevoke)
  .add('batchPublish').icon('icon-tijiao').text('publish').sort(30).disabled(publishDisabled).handle(batchPublish)
  .add('batchInvalidate').icon('icon-shanchu').text('invalidate').sort(40).disabled(invalidateDisabled).handle(batchInvalidate)
  .lib('delete').text('delete').sort(50).disabled(deleteDisabled).handle(batchDelete)

const search = new Search('performanceAppraisal.performanceAppraisal.search')
  .placeholder('placeholder')
  .add('purchaseUnitNos').select(Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1', accessControlFlag: 'N' })).attrs({ multiple: true })
  .add('examineStartTime').merge('date').label('examineStartTime')
  .add('examineEndTime').merge('date').label('examineEndTime')
  .add('addByName').label('addbyName')
  .add('supplierNos').component(SupplierInput)
  .add('statusList').op('appraisalStatus').attrs({ multiple: true })
  .add('examineSource').op('examineSourceName')
  .add('judgePerson')

const statusTabs = new Tabs()
  .api(function() {
    return http<any[]>({
      url: '/examineProcess/getProcessCount',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: {}
    }).then(res => {
      return res.map(item => ({ ...item, status: `${item.status}` }))
    })
  })
  .name('statusName')
  .value('status')
  .count('statusCount')
  .prop('status')
  .default('all')

const table = new Table('performanceAppraisal.performanceAppraisal.table')
  .edit(true)
  .type('selection')
  .add('processNo').link()
  .add('purchaseUnitName')
  .add('assessSystemName')
  .add('workingPeriod').label('examineProcessPeriod').html((data) => {
    return data.row.examineProcessPeriod || ''
  })
  .add('examineYear')
  .add('examineQuarter')
  .add('examineMonth')
  .add('examineSource').label('examineSourceName').html((data) => {
    return data.row.examineSourceName || ''
  })
  .add('addByName')
  .add('status').label('processStatusName').component(statusDot)

function getRouteParam(row: any) {
  return {
    processNo: row.processNo,
    judgeType: row.judgeType,
    assessSystemName: row.assessSystemName,
    assessSystemNo: row.assessSystemNo,
    purchaseUnitName: row.purchaseUnitName,
    purchaseUnitNo: row.purchaseUnitNo,
    workingPeriod: row.workingPeriod,
    workingPeriodName: row.workingPeriodName,
    workingDateName: row.workingDateName
  }
}

// 发布
async function publish(this: any, row: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.publishTip`))
  await http({
    url: '/examineProcess/changeStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    params: { status: '4', processNo: row.processNo }
  })
  this.refresh()
}

// 查看结果
function lookResult(this: any, row: any) {
  this.$router.push({ name: 'PerformanceAppraisal.PerformanceAppraisal.ViewResult', params: { ...row }})
}

// 查看评分
function lookViewScore(this: any, row: any) {
  const { processNo, purchaseUnitNo, assessSystemNo, judgeType, assessSystemName, purchaseUnitName, workingPeriodName, workingDateName } = row
  const query = { processNo, purchaseUnitNo, assessSystemNo, judgeType, assessSystemName, purchaseUnitName, workingPeriodName, workingDateName }
  this.$router.push({ name: 'PerformanceAppraisal.PerformanceAppraisal.ViewMark', query })
}

// 作废
async function invalidate(this: any, row: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.invalidateTip`))
  await http({
    url: '/examineProcess/changeStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    params: { status: '3', processNo: row.processNo }
  })
  this.refresh()
}

// 撤销
async function revoke(this: any, row: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.revokeTip`))
  await http({
    url: '/examineProcess/changeStatus',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    params: { status: '0', processNo: row.processNo }
  })
  this.refresh()
}

// 删除
async function deleteTip(this: any, row: any) {
  await this.$confirm(this.$t(`performanceAppraisal.performanceAppraisal.deleteTip`))
  await http({
    url: '/examineProcess/deleteExamineProcess',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    params: { delflg: '1', processNo: row.processNo }
  })
  this.refresh()
}

// 评分
async function goMark(this: any, row: any) {
  const routeParam: any = {
    mark: true,
    ...getRouteParam(row)
  }
  // 跳转页面
  await this.$router.push({ name: 'PerformanceAppraisal.PerformanceAppraisal.Mark', params: routeParam })
}

const operation = new Operation('performanceAppraisal.performanceAppraisal')
  .width(250)
  .add('judgeScore').show(row => ['0'].includes(row.status) && row.judgeFlag && !row.judgeFinishFlag && row.assessSystemNo !== '0000').handle(goMark)
  .add('revoke').show(row => ['1'].includes(row.status) && row.builderFlag).handle(revoke)
  .add('publish').show(row => (['2'].includes(row.status) && row.builderFlag)).handle(publish)
  .add('lookResult').show(row => (['4'].includes(row.status) && row.allJudgeFinishFlag)).handle(lookResult)
  .add('viewScore').show(row => ['0'].includes(row.status) && row.judgeFlag && row.judgeFinishFlag).handle(lookViewScore)
  .add('invalidate').show(row => (['0', '2'].includes(row.status) && row.builderFlag)).handle(invalidate)
  .add('delete').show(row => (['0'].includes(row.delflg) && row.builderFlag)).handle(deleteTip)

export default new List()
  .name('PerformanceAppraisal.PerformanceAppraisal')
  .operation(operation)
  .api(api)
  .tabs(statusTabs)
  .search(search)
  .jurisdiction(jurisdiction)
  .table(table)
  .detail(Detail)
  .end()
